import { render, staticRenderFns } from "./feedback_received.vue?vue&type=template&id=c3c11b1a"
import script from "./feedback_received.vue?vue&type=script&lang=js"
export * from "./feedback_received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports